import { useParams } from "react-router";
import {
  getAnnouncementDoc,
  getUserNotificationCollection,
  tokensCollectionRef,
} from "../utils/firestoreHelpers";
import { useCollection, useDocumentData } from "react-firebase-hooks/firestore";
import { Loader } from "../hooks/useLoading";
import SearchUsers from "../components/searchUsers";
import { useEffect, useState } from "react";
import { useHttpsCallable } from "react-firebase-hooks/functions";
import { getFunctions } from "firebase/functions";
import { db, firebaseApp } from "../config/firebase";
import {
  writeBatch,
  doc,
  getDocs,
  where,
  query,
  updateDoc,
} from "firebase/firestore";
import { usersQuery } from "../utils/queryHelpers";
import AddAnnouncements from "../components/addAnnouncement";
import { toastMessage } from "../utils/toastMessage";
import { userStatusTypes } from "../utils/constants";

const AnnouncementsDetails = () => {
  const { id } = useParams();
  const [showEditModal, setShowEditModal] = useState(false);
  const annDoc = getAnnouncementDoc(id);
  const [userList, setUserList] = useState([]);
  const [userListSet, setUserListSet] = useState(new Set());
  const [loading, setLoading] = useState(false);
  const [dialogType, setDialogType] = useState("Edit");
  const [userData, setUserData] = useState([]);
  const [announcementData, docLoading, error, snapshot] =
    useDocumentData(annDoc);
  const [executeCallable, executing, functionError] = useHttpsCallable(
    getFunctions(firebaseApp),
    "sendNotification"
  );

  // get users function hook
  const [userSnapshot, userLoading, userError] = useCollection(usersQuery(), {
    snapshotListenOptions: {
      includeMetadataChanges: true,
    },
  });

  const [
    verifiedUsersList,
    // verifiedUsersListExecuting,
    // verifiedUsersListError,
  ] = useHttpsCallable(getFunctions(firebaseApp), "getVerifiedUsersList");

  const handleGetFirebaseUsers = async () => {
    try {
      // let userListVerified = await getFirebaseUsers();
      let userListVerified = await verifiedUsersList();
      return userListVerified;
    } catch (error) {
      console.log("error :: ", error);
      return [];
    }
  };

  let { JOINED } = userStatusTypes;

  const getUserFromDb = async () => {
    try {
      let { data } = await handleGetFirebaseUsers();
      let verifiedUserIds = data?.authUsersData
        ?.filter((item) => item.emailVerified || item.phoneNumber !== null)
        .map((item) => item.uid);

      // extract user data from data snapshots
      let userData =
        userSnapshot?.docs
          ?.map((data) => {
            const d = { ...data.data(), id: data.id };
            return d;
          })
          .filter((user) => {
            return (
              ["undefined", undefined, JOINED].includes(user.status) &&
              verifiedUserIds?.includes(user.id)
            );
          })
          .filter((user) =>
            ["undefined", undefined, false].includes(user.deleted)
          ) || [];

      setUserData(userData);
    } catch (error) {
      setUserData([]);
      console.log("error :: ", error);
    }
  };

  const onSend = async () => {
    try {
      setLoading(true);
      const batch = writeBatch(db);
      const selectedUsers = userList.length === 0 ? userData : userList;
      selectedUsers.forEach((user) => {
        const userRef = doc(
          db,
          getUserNotificationCollection(user.id),
          snapshot.id
        );
        batch.set(userRef, {
          date: new Date(),
          ref: snapshot.ref,
          title: announcementData.title,
          description: announcementData.description,
          type: announcementData.type,
          id: snapshot.id,
          main_type: "Announcement",
          opened: false,
        });
      });
      try {
        await batch.commit();
      } catch (e) {}

      const tokens = [];
      let queryDocs = [];
      const ids = selectedUsers.map((user) => user.id);
      let slotNumber = ids.length / 30;
      for (let i = 0; i < slotNumber; i++) {
        const tokenQuery =
          ids.length === 0
            ? query(tokensCollectionRef, where("token", "!=", null))
            : query(
                tokensCollectionRef,
                where(
                  "__name__",
                  "in",
                  ids.slice(30 * i + 30 - (i === 0 ? 30 : 29), 30 * i + 30)
                )
                // where("token", "!=", null)
              );
        let tempQueryDocs = await getDocs(tokenQuery);
        queryDocs = [...queryDocs, ...tempQueryDocs.docs];
      }

      for (const doc of queryDocs) {
        const token = doc.data().token;
        if (token) {
          tokens.push(token);
        }
      }
      if (tokens.length === 0) return;
      await executeCallable({
        token: tokens.length === 1 ? tokens[0] : tokens,
        payload: {
          title: announcementData.title,
          body: announcementData.description,
          channel_id: `notification ${id} Announcement`,
          type: "notification",
          mainType: "Announcement",
          image: announcementData["image_url"],
        },
      });
      let updateDocToDelivered = await handleDelivery();
      toastMessage("Sent Successfully ", "success");
    } catch (e) {
      toastMessage("Failed to send", "error");
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const handleDelivery = async () => {
    const annDoc = getAnnouncementDoc(id);
    await updateDoc(annDoc, { expired: true });

    return true;
  };

  useEffect(() => {
    getUserFromDb();
    return () => {};
  }, [userSnapshot]);

  return (
    <main className="d-flex gap-1 flex-wrap">
      {(docLoading || executing || loading || userLoading) && (
        <Loader style={{ zIndex: 100 }} />
      )}
      {error ? (
        <p className="text-error">
          There is some error. Please try again later
        </p>
      ) : null}
      {announcementData ? (
        <div className="d-flex justify-content-between align-items-center w-100">
          <div>
            <strong>Title :</strong> {announcementData.title} <br />
            <strong> Description:</strong>{" "}
            {announcementData.description || "N/A"}{" "}
          </div>
          {showEditModal ? (
            <AddAnnouncements
              selected={{ ...announcementData, id: snapshot.id }}
              onClose={() => {
                setShowEditModal(false);
              }}
              dialogType={dialogType}
            />
          ) : null}
          <button
            className="btn btn-dark"
            onClick={() => {
              setShowEditModal(true);
            }}
          >
            Edit
          </button>
        </div>
      ) : null}
      <hr className="border-top border-top-1 border-top-black" />
      <div className="d-flex w-100 gap-3">
        <div className="flex-fill list-group list-group-flush">
          {userList.length > 0 ? (
            <div className="d-flex justify-content-between">
              <button
                className="btn btn-danger"
                onClick={() => {
                  setUserList([]);
                  setUserListSet(new Set([]));
                }}
              >
                Remove All
              </button>
              <button onClick={onSend} className="btn btn-success">
                Send Selected
              </button>
            </div>
          ) : (
            <button className="btn btn-success" onClick={onSend}>
              Send All
            </button>
          )}
          {userList?.length ? (
            <div
              className="mt-2"
              style={{ borderRadius: "6px", border: "1px solid lightgrey" }}
            >
              {userList.map((user, index) => (
                <div
                  className=""
                  style={{
                    padding: "10px",
                    borderBottom:
                      userList.length === index + 1
                        ? "0px solid lightgrey"
                        : "1px solid lightgrey",
                  }}
                >
                  {user.first_name} {user.last_name}
                </div>
              ))}
            </div>
          ) : null}
        </div>
        <div className="flex-fill" style={{ zIndex: loading ? -10 : 0 }}>
          <SearchUsers
            setUserList={setUserList}
            userListSet={userListSet}
            setUserListSet={setUserListSet}
            userSnapshot={userData}
            userError={userError}
          />
        </div>
      </div>
    </main>
  );
};

export default AnnouncementsDetails;
